// extracted by mini-css-extract-plugin
export var acitonButtons = "_fz-0";
export var additionalIcon = "_fz-f";
export var block = "_fz-1";
export var blockContent = "_fz-7";
export var blockDescription = "_fz-8";
export var blockIcon = "_fz-9";
export var blockTitle = "_fz-6";
export var border = "_fz-a";
export var center = "_fz-l";
export var edge = "_fz-b";
export var edgeLabel = "_fz-c";
export var edgePath = "_fz-d";
export var error = "_fz-e";
export var flowchart = "_fz-g";
export var flowchartContent = "_fz-h";
export var highlighted = "_fz-3";
export var hover = "_fz-4";
export var icon = "_fz-i";
export var left = "_fz-m";
export var navButton = "_fz-j";
export var navButtons = "_fz-k";
export var right = "_fz-n";
export var selected = "_fz-2";
export var small = "_fz-5";